import { render } from "./list_restrictions.vue?vue&type=template&id=66316030"
import script from "./list_restrictions.vue?vue&type=script&lang=js"
export * from "./list_restrictions.vue?vue&type=script&lang=js"

import "./list_restrictions.vue?vue&type=style&index=0&id=66316030&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__